import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

var useIsInDialog = function useIsInDialog(el) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    inDialog = _useState2[0],
    setInDialog = _useState2[1];
  useEffect(function () {
    if (el && inDialog === null) {
      setInDialog(!!el.closest('dialog'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [el]);
  return inDialog;
};

export { useIsInDialog };
